import { sideMenuLang } from './sideMenu'
import { sideMenuCategoryLang } from './sideMenuCategory'
import { ISideMenuAllLang } from '../../../types/lang'

export const sideMenuAllLang: ISideMenuAllLang = {
	...sideMenuLang,
	...sideMenuCategoryLang
}